export class KeywordMetricsRequest {
  domain: string;
  keywords: string[];
  startDate: any;
  endDate: any;
  rowLimit: number;
}
